import React from 'react';
import { Table } from 'react-bootstrap';

const TableView = ({ bykets }) => {
  return (
    <Table striped bordered hover className="mt-3">
      <thead>
        <tr>
          <th>Назва</th>
          <th>#</th>
        </tr>
      </thead>
      <tbody>
        {bykets.map((product, index) => (
          <tr key={product.id}>
            <td>{product.name}</td>
            <td>{index + 1}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default TableView;
